import '../../../assets/css/style.min.css'
import { initializeApp } from 'firebase/app';
import { firebaseConfig } from '../../../components/config';
import { getAnalytics } from 'firebase/analytics';
import { collection, doc, getDoc, getDocs, getFirestore, onSnapshot, orderBy, query, where, deleteDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { capitalizeFirstLetter, form, g, log, openModal_v2, q, sortObject, t } from '../../../../../utils';
import { User } from '../../../components/user';

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore()

const dashboardApp = "delivery"

const user = new User(app)

async function initDashboard(uid, activeSubCallback, inactiveSubCallback) {
  getDoc(doc(firestore, `dashboard/${uid}`)).then((dashboardAppSubscription) => {
    if (dashboardAppSubscription.exists()) {
      const operatorData = dashboardAppSubscription.data()

      const appHandler = (mDashboardApp) => {
        if (mDashboardApp != undefined) {
          if (mDashboardApp.active) {
            const expires = mDashboardApp.expires.toDate()
            const now = new Date()

            if (now.getTime() < expires.getTime()) {
              activeSubCallback(mDashboardApp)
            } else { inactiveSubCallback() }
          } else { inactiveSubCallback() }
        } else { inactiveSubCallback() }
      }


      if (dashboardApp === "ride") {
        appHandler(operatorData)
      } else {
        appHandler(operatorData[dashboardApp])
      }
    } else {
      inactiveSubCallback()
    }
  }).catch((e) => {
    log(e.message)
  })
}

user.init(async (u) => {
  initDashboard(u.uid, async (operatorData) => {
    const appId = operatorData["appId"]

    var d = new Date();
    d.setHours(0, 0, 0, 0);

    let currentRideRef;

    let modifiedNotification = new Audio('https://firebasestorage.googleapis.com/v0/b/kudu-ride.appspot.com/o/1_system%2Fweb%2Fmixkit-bell-notification-933.wav?alt=media&token=945a9641-f6b8-4b4c-800a-f0ddaa52b1d1&_gl=1*xyd9kx*_ga*MTQwNDM4Mjc1MC4xNjc5NDg4OTI3*_ga_CW55HF8NVT*MTY5NTk2OTU3OC41MjkuMS4xNjk1OTY5ODE2LjYwLjAuMA..')
    let addedNotification = new Audio('https://firebasestorage.googleapis.com/v0/b/kudu-ride.appspot.com/o/1_system%2Fweb%2Fmixkit-bubble-pop-up-alert-notification-2357.wav?alt=media&token=cd3e204b-456c-4b4e-9d54-34fc8b9bfe99&_gl=1*1ims33a*_ga*MTQwNDM4Mjc1MC4xNjc5NDg4OTI3*_ga_CW55HF8NVT*MTY5NTk4OTY3Mi41MzIuMS4xNjk1OTkwMTcyLjE3LjAuMA..')

    var ridesCol = collection(firestore, "deliveries")

    var constraints = [
      where("app", "==", appId),
      where("timestamp", ">=", d),
      orderBy("timestamp", "desc")
    ]

    var mQuery = query(ridesCol, ...constraints)

    const data = g("data")

    function driver(data) {
      if (data.stage > 0) {
        return `<td class="int-table__cell"><a href="../users/user/?id=${data.driver}">${data.driverName}</a></td>`
      } else {
        return `<td class="int-table__cell">---</td>`
      }
    }

    async function updateDetails(rideId) {
      currentRideRef = doc(firestore, "rides", rideId)

      const ride = await getDoc(currentRideRef)

      if (ride.exists()) {
        const rideData = sortObject(ride.data())

        g("_timestamp").innerText = rideData.timestamp.toDate()
        g("_stage").innerText = rideData.stage
        g("modal-title").innerText = `${rideData.destination} - ${rideData.locality}`
        g("_estimatedFare2").innerText = `ZMW${rideData.estimatedFare}`

        const info = g("_info")
        info.innerHTML = ""

        for (const key in rideData) {
          if (Object.hasOwnProperty.call(rideData, key)) {
            const element = rideData[key];

            console.log(key);

            switch (key) {
              case "@accepted":
                info.appendChild(t(`<tr class="prop-table__row">
                      <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                      <td class="prop-table__cell">${element.toDate()}</td>
                  </tr>`))
                break;
              case "timestamp":
                info.appendChild(t(`<tr class="prop-table__row">
                      <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                      <td class="prop-table__cell">${element.toDate()}</td>
                  </tr>`))
                break
              case "@arrived":
                info.appendChild(t(`<tr class="prop-table__row">
                      <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                      <td class="prop-table__cell">${element.toDate()}</td>
                  </tr>`))
                break
              case "@canceled":
                info.appendChild(t(`<tr class="prop-table__row">
                      <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                      <td class="prop-table__cell">${element.toDate()}</td>
                  </tr>`))
                break
              default:
                info.appendChild(t(`<tr class="prop-table__row">
                      <th class="prop-table__cell prop-table__cell--th">${capitalizeFirstLetter(key)}</th>
                      <td class="prop-table__cell">${element}</td>
                  </tr>`))
                break;
            }
          }
        }
      }
    }

    const unsub = onSnapshot(mQuery, (rides) => {
      data.innerHTML = ""

      rides.forEach(ride => {
        const rideData = ride.data()

        data.appendChild(t(`<tr class="int-table__row">
            <th class="int-table__cell" scope="row">
                <div class="custom-checkbox int-table__checkbox">
                    <input class="custom-checkbox__input js-int-table__select-row"
                        type="checkbox" aria-label="Select this row" />
                    <div class="custom-checkbox__control" aria-hidden="true"></div>
                </div>
            </th>
            <td class="int-table__cell"><a class="ride__link" data-ride-id="${ride.id}" href="#${ride.id}">${ride.id}</a></td>
            ${driver(rideData)}
            <td class="int-table__cell">${rideData.stage}</td>
            <td class="int-table__cell text-truncate max-width-xxxxs">ZMW${rideData.estimatedFare}</td>
            <td class="int-table__cell">${rideData.timestamp.toDate()}</td>
            <td class="int-table__cell">${rideData.locality}</td>
            <td class="int-table__cell">
                <button class="reset int-table__menu-btn margin-left-auto js-tab-focus"
                    data-label="Edit row" aria-controls="menu-example">
                    <svg class="icon" viewBox="0 0 16 16">
                        <circle cx="8" cy="7.5" r="1.5" />
                        <circle cx="1.5" cy="7.5" r="1.5" />
                        <circle cx="14.5" cy="7.5" r="1.5" />
                    </svg>
                </button>
            </td>
        </tr>`))
      });


      q(".ride__link").forEach(link => {
        link.addEventListener("click", (e) => {
          e.preventDefault()

          console.log("asdfghjk");

          const rideId = link.getAttribute("data-ride-id")
          updateDetails(rideId)
          openModal_v2("modal-ride", () => { })
        })
      })

      rides.docChanges().forEach((change) => {
        if (change.type === "added") {
          console.log("New city: ", change.doc.data());
          modifiedNotification.play()
        }
        if (change.type === "modified") {
          console.log("Modified city: ", change.doc.data());
          addedNotification.play()
        }
        if (change.type === "removed") {
          console.log("Removed city: ", change.doc.data());
        }
      });
    })

    function compareDate(str1) {
      // str1 format should be dd/mm/yyyy. Separator can be anything e.g. / or -. It wont effect
      var dt1 = parseInt(str1.substring(0, 2));
      var mon1 = parseInt(str1.substring(3, 5));
      var yr1 = parseInt(str1.substring(6, 10));
      var date1 = new Date(yr1, mon1 - 1, dt1);
      return date1;
    }

    form("rides_filter", async (data) => {
      unsub()

      const q = query(
        collection(db, "cities"),
        where("timestamp", ">=", compareDate(data.ridesFilterDate))
      );

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        console.log(doc.id, " => ", doc.data());
      });
    })

    g("btn_delete_ride").addEventListener("click", () => {
      let del = confirm("Are you sure to delete ride record?");

      if (del) {
        deleteDoc(currentRideRef)
          .then(() => {
            alert("Deleted successfully!")
            location.reload()
          }).catch((e) => {
            alert(e.message)
            location.reload()
          })
      }
    })
  }, () => { location.replace('../../subscribe/delivery') })
}, () => { location.replace('../../account/login') })

require('../../../assets/js/scripts')